// assets/delivery-calendar.js
// Hardened build: renders the calendar FIRST (always visible, never blocked by the
// product form lookup), wires add-to-cart lazily, guards against double-include,
// and re-inits on Shopify section load. Keeps prior optimisations (DOM reuse,
// event delegation, cached timestamps, partial updates on click).

(function () {
  'use strict';

  // ── Global guard: if this file is included twice on a page, only boot once ──
  if (window.__PDC_CALENDAR_BOOTED__) return;
  window.__PDC_CALENDAR_BOOTED__ = true;

  // ─── Helpers ────────────────────────────────────────────────────────────────

  function parseIntOrNull(value) {
    if (value === undefined || value === null || value === '') return null;
    var n = parseInt(value, 10);
    return isNaN(n) ? null : n;
  }
  function startOfDay(date) { return new Date(date.getFullYear(), date.getMonth(), date.getDate()); }
  function addDays(date, days) { var d = new Date(date.getFullYear(), date.getMonth(), date.getDate()); d.setDate(d.getDate() + days); return d; }
  function addMonths(date, months) { var d = new Date(date.getFullYear(), date.getMonth(), 1); d.setMonth(d.getMonth() + months); return d; }
  function isWeekend(date) { var day = date.getDay(); return day === 0 || day === 6; }
  function clampDateToMonthRange(date, minDate, maxDate) {
    var d = new Date(date.getFullYear(), date.getMonth(), 1);
    var minM = new Date(minDate.getFullYear(), minDate.getMonth(), 1);
    var maxM = new Date(maxDate.getFullYear(), maxDate.getMonth(), 1);
    if (d < minM) return minM; if (d > maxM) return maxM; return d;
  }
  function formatDateForCustomer(date) {
    if (!date) return '';
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return date.getDate() + ' ' + months[date.getMonth()] + ' ' + date.getFullYear();
  }
  function toISODate(date) {
    return date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
  }
  function dateFromISO(str) { var p = str.split('-'); return new Date(+p[0], +p[1] - 1, +p[2]); }
  function createPdcBookingId() { return 'pdc_' + Date.now() + '_' + Math.random().toString(36).slice(2, 9); }
  function cartUrl(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return root.replace(/\/$/, '') + path;
  }
  function formatMoney(cents) {
    if (cents === null || cents === undefined) return '';
    if (window.DELIVERY_CALENDAR_CONFIG && window.DELIVERY_CALENDAR_CONFIG.money_format &&
        window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.DELIVERY_CALENDAR_CONFIG.money_format);
    }
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') return window.Shopify.formatMoney(cents);
    return '$' + (cents / 100).toFixed(2);
  }

  var WEEKDAY_NAMES = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  var MONTH_NAMES = ['January','February','March','April','May','June','July','August','September','October','November','December'];

  // ─── Core ───────────────────────────────────────────────────────────────────

  function initCalendar(container) {
    if (container.dataset.pdcInitialized === 'true') return;
    container.dataset.pdcInitialized = 'true';

    // Data attributes
    var basePriceCents            = parseIntOrNull(container.dataset.basePrice);
    var priorityUpgradeVariantId  = container.dataset.priorityUpgradeVariantId || null;
    var priorityUpgradePriceCents = parseIntOrNull(container.dataset.priorityUpgradePrice) || 0;
    var rushUpgradeVariantId      = container.dataset.rushUpgradeVariantId || null;
    var rushUpgradePriceCents     = parseIntOrNull(container.dataset.rushUpgradePrice) || 0;
    var seaUpgradeVariantId       = container.dataset.seaUpgradeVariantId || null;
    var seaUpgradePriceCents      = parseIntOrNull(container.dataset.seaUpgradePrice) || 0;

    var standardStartOffset = parseIntOrNull(container.dataset.standardStartOffsetDays);
    var standardEndOffset   = parseIntOrNull(container.dataset.standardEndOffsetDays);
    var priorityStartOffset = parseIntOrNull(container.dataset.priorityStartOffsetDays);
    var priorityEndOffset   = parseIntOrNull(container.dataset.priorityEndOffsetDays);
    var rushStartOffset     = parseIntOrNull(container.dataset.rushStartOffsetDays);
    var rushEndOffset       = parseIntOrNull(container.dataset.rushEndOffsetDays);
    var seaStartOffset      = parseIntOrNull(container.dataset.seaStartOffsetDays);
    var seaEndOffset        = parseIntOrNull(container.dataset.seaEndOffsetDays);

    // DOM refs
    var selectedEl   = container.querySelector('.delivery-calendar__selected');
    var windowInfoEl = container.querySelector('.delivery-calendar__window-info');
    var pricingEl    = container.querySelector('.delivery-calendar__pricing');
    var legendEl     = container.querySelector('.delivery-calendar__legend');
    var prevBtn      = container.querySelector('.delivery-calendar__nav--prev');
    var nextBtn      = container.querySelector('.delivery-calendar__nav--next');
    var monthEl      = container.querySelector('.delivery-calendar__month');
    var weekdaysEl   = container.querySelector('.delivery-calendar__weekdays');
    var gridEl       = container.querySelector('.delivery-calendar__grid');

    // Form refs are resolved LATER (lazily) — the calendar must never wait for them.
    var productForm = null;
    var addButton   = null;

    function getCurrentVariantId() {
      var scope = productForm || document;
      var input = scope.querySelector('input[name="id"]');
      if (input && input.value) return input.value;
      var select = scope.querySelector('select[name="id"]');
      if (select && select.value) return select.value;
      return null;
    }

    // Window config.
    // Standard is ALWAYS available (falls back to a default lead time).
    // Priority / Rush / Sea are OPTIONAL: a tier only appears when BOTH its
    // start and end offsets are set on the product. Empty metafield -> no pill.
    var windowsConfig = {
      standard: { key:'standard', label:'Standard', cartLabel:'Standard',
        leadMinDays: standardStartOffset !== null ? standardStartOffset : 41,
        leadMaxDays: standardEndOffset   !== null ? standardEndOffset   : 90, surchargeCents:0, visible:true },
      priority: { key:'priority', label:'Priority', cartLabel:'Priority Build',
        leadMinDays: priorityStartOffset !== null ? priorityStartOffset : 21,
        leadMaxDays: priorityEndOffset   !== null ? priorityEndOffset   : 40, surchargeCents: priorityUpgradePriceCents || 0,
        visible: priorityStartOffset !== null && priorityEndOffset !== null },
      rush: { key:'rush', label:'Rush', cartLabel:'Rush Build',
        leadMinDays: rushStartOffset !== null ? rushStartOffset : 10,
        leadMaxDays: rushEndOffset   !== null ? rushEndOffset   : 20, surchargeCents: rushUpgradePriceCents || 0,
        visible: rushStartOffset !== null && rushEndOffset !== null },
      sea: { key:'sea', label:'Sea', cartLabel:'Sea Freight',
        leadMinDays: seaStartOffset !== null ? seaStartOffset : 21,
        leadMaxDays: seaEndOffset   !== null ? seaEndOffset   : 120, surchargeCents: seaUpgradePriceCents || 0,
        visible: seaStartOffset !== null && seaEndOffset !== null }
    };

    var today   = startOfDay(new Date());
    var todayTs = today.getTime();

    var windowTs = {};
    ['standard', 'priority', 'rush', 'sea'].forEach(function (key) {
      var cfg = windowsConfig[key];
      windowTs[key] = { start: addDays(today, cfg.leadMinDays).getTime(), end: addDays(today, cfg.leadMaxDays).getTime() };
    });

    // Visible date range spans only the tiers that are actually offered.
    var minLead = windowsConfig.standard.leadMinDays;
    var maxLead = windowsConfig.standard.leadMaxDays;
    ['priority', 'rush', 'sea'].forEach(function (k) {
      if (windowsConfig[k].visible) {
        minLead = Math.min(minLead, windowsConfig[k].leadMinDays);
        maxLead = Math.max(maxLead, windowsConfig[k].leadMaxDays);
      }
    });

    var fullMinDate = addDays(today, minLead);
    var fullMaxDate = addDays(today, maxLead);
    var fullMinTs = fullMinDate.getTime(), fullMaxTs = fullMaxDate.getTime();
    var fullMinMonth = new Date(fullMinDate.getFullYear(), fullMinDate.getMonth(), 1).getTime();
    var fullMaxMonth = new Date(fullMaxDate.getFullYear(), fullMaxDate.getMonth(), 1).getTime();

    function getVisualWindowForTs(ts) {
      if (windowsConfig.rush.visible     && ts >= windowTs.rush.start     && ts <= windowTs.rush.end)     return 'rush';
      if (windowsConfig.priority.visible && ts >= windowTs.priority.start && ts <= windowTs.priority.end) return 'priority';
      if (ts >= windowTs.standard.start && ts <= windowTs.standard.end) return 'standard';
      if (windowsConfig.sea.visible && ts >= windowTs.sea.start && ts <= windowTs.sea.end) return 'sea';
      return null;
    }

    var selectedWindowKey = 'standard';
    var selectedDate = null, selectedTs = null, currentMonth = null;

    function getFirstDateForWindow(key) {
      var cfg = windowsConfig[key];
      if (!cfg) return fullMinDate;
      var d = addDays(today, cfg.leadMinDays);
      var endTs = windowTs[key].end;
      while (d.getTime() <= endTs && d.getTime() <= fullMaxTs) {
        if (!isWeekend(d) && getVisualWindowForTs(d.getTime()) === key) return d;
        d = addDays(d, 1);
      }
      return addDays(today, cfg.leadMinDays);
    }

    selectedDate = getFirstDateForWindow('standard');
    selectedTs   = selectedDate.getTime();
    currentMonth = clampDateToMonthRange(selectedDate, fullMinDate, fullMaxDate);

    // Weekdays
    if (weekdaysEl && !weekdaysEl.children.length) {
      var wFrag = document.createDocumentFragment();
      WEEKDAY_NAMES.forEach(function (name) {
        var el = document.createElement('div'); el.className = 'delivery-calendar__weekday'; el.textContent = name; wFrag.appendChild(el);
      });
      weekdaysEl.appendChild(wFrag);
    }

    // Grid — 42 reusable cells
    var cells = [];
    if (gridEl) {
      var gFrag = document.createDocumentFragment();
      for (var ci = 0; ci < 42; ci++) {
        var cell = document.createElement('button'); cell.type = 'button'; cell.className = 'delivery-calendar__day';
        gFrag.appendChild(cell); cells.push(cell);
      }
      gridEl.appendChild(gFrag);
      gridEl.addEventListener('click', function (e) {
        var btn = e.target.closest('.delivery-calendar__day');
        if (!btn || btn.disabled) return;
        var dateStr = btn.dataset.date; if (!dateStr) return;
        var d = dateFromISO(dateStr), ts = d.getTime(), key = getVisualWindowForTs(ts);
        if (!key) return;
        selectedDate = d; selectedTs = ts; selectedWindowKey = key;
        updateCellSelection(); updateTexts(); updateLegendActiveState();
      });
    }

    function buildLegend() {
      if (!legendEl) return;
      legendEl.innerHTML = '';
      var entries = [ {key:'standard',cls:'is-standard'}, {key:'priority',cls:'is-priority'}, {key:'rush',cls:'is-rush'}, {key:'sea',cls:'is-sea'} ];
      var frag = document.createDocumentFragment();
      entries.forEach(function (entry) {
        var cfg = windowsConfig[entry.key]; if (!cfg || !cfg.visible) return;
        var btn = document.createElement('button'); btn.type = 'button';
        btn.className = 'delivery-calendar__pill ' + entry.cls; btn.textContent = cfg.label;
        btn.setAttribute('data-delivery-window', entry.key);
        btn.addEventListener('click', function () { setSelectedWindow(entry.key, true); });
        frag.appendChild(btn);
      });
      legendEl.appendChild(frag);
      updateLegendActiveState();
    }
    function updateLegendActiveState() {
      if (!legendEl) return;
      legendEl.querySelectorAll('.delivery-calendar__pill').forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-delivery-window') === selectedWindowKey);
      });
    }

    function renderCalendar() {
      if (!gridEl) return;
      var year = currentMonth.getFullYear(), month = currentMonth.getMonth();
      if (monthEl) monthEl.textContent = MONTH_NAMES[month] + ' ' + year;
      var firstWeekday = new Date(year, month, 1).getDay();
      var offset = (firstWeekday + 6) % 7;
      for (var i = 0; i < 42; i++) {
        var cell = cells[i], dayNum = i - offset + 1;
        var cellDate = new Date(year, month, dayNum), cellTs = cellDate.getTime();
        cell.textContent = String(cellDate.getDate());
        cell.dataset.date = toISODate(cellDate);
        cell.disabled = false;
        cell.className = 'delivery-calendar__day';
        var inCurrentMonth = cellDate.getMonth() === month && cellDate.getFullYear() === year;
        if (!inCurrentMonth) cell.classList.add('is-adjacent-month');
        var windowKey = getVisualWindowForTs(cellTs);
        if (windowKey) cell.classList.add('is-window-' + windowKey);
        var weekend = isWeekend(cellDate);
        if (weekend) cell.classList.add('is-weekend');
        var disabled = cellTs < fullMinTs || cellTs > fullMaxTs || !windowKey || weekend;
        if (disabled) { cell.disabled = true; cell.classList.add('is-disabled'); }
        if (cellTs === selectedTs) cell.classList.add('is-selected');
        if (cellTs === todayTs)    cell.classList.add('is-today');
      }
      if (prevBtn) prevBtn.disabled = new Date(year, month - 1, 1).getTime() < fullMinMonth;
      if (nextBtn) nextBtn.disabled = new Date(year, month + 1, 1).getTime() > fullMaxMonth;
    }

    function updateCellSelection() {
      for (var i = 0; i < 42; i++) {
        var cell = cells[i], dateStr = cell.dataset.date; if (!dateStr) continue;
        var isNowSelected = dateFromISO(dateStr).getTime() === selectedTs;
        if (cell.classList.contains('is-selected') !== isNowSelected) cell.classList.toggle('is-selected', isNowSelected);
      }
    }

    function setSelectedWindow(key, moveDateToWindow) {
      if (!windowsConfig[key]) return;
      selectedWindowKey = key;
      if (moveDateToWindow) {
        var newDate = getFirstDateForWindow(key);
        selectedDate = newDate; selectedTs = newDate.getTime();
        var newMonthTs = new Date(newDate.getFullYear(), newDate.getMonth(), 1).getTime();
        var curMonthTs = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), 1).getTime();
        if (newMonthTs !== curMonthTs) { currentMonth = new Date(newDate.getFullYear(), newDate.getMonth(), 1); renderCalendar(); }
        else { updateCellSelection(); }
      } else { updateCellSelection(); }
      updateTexts(); updateLegendActiveState();
    }

    function updateTexts() {
      if (!selectedDate || !selectedWindowKey) {
        if (selectedEl) selectedEl.textContent = 'No date selected yet.';
        if (windowInfoEl) windowInfoEl.innerHTML = '';
        if (pricingEl) pricingEl.textContent = '';
        return;
      }
      var cfg = windowsConfig[selectedWindowKey];
      if (selectedEl) selectedEl.innerHTML = 'Selected date: <strong>' + formatDateForCustomer(selectedDate) + '</strong>';
      if (windowInfoEl) windowInfoEl.innerHTML = '';
      if (!pricingEl || !basePriceCents) return;
      var totalCents = basePriceCents + (cfg.surchargeCents || 0);
      var html = 'Total with <strong>' + cfg.label + '</strong>: <strong>' + formatMoney(totalCents) + '</strong>. ';
      if (cfg.surchargeCents && cfg.surchargeCents > 0) html += 'Includes a <strong>' + formatMoney(cfg.surchargeCents) + '</strong> speed upgrade.';
      else if (selectedWindowKey === 'standard') html += 'No extra production fee applies.';
      pricingEl.innerHTML = html;
    }

    if (prevBtn) prevBtn.addEventListener('click', function () {
      var prev = addMonths(currentMonth, -1);
      if (new Date(prev.getFullYear(), prev.getMonth(), 1).getTime() < fullMinMonth) return;
      currentMonth = prev; renderCalendar();
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      var next = addMonths(currentMonth, 1);
      if (new Date(next.getFullYear(), next.getMonth(), 1).getTime() > fullMaxMonth) return;
      currentMonth = next; renderCalendar();
    });

    // ── RENDER FIRST — calendar is now visible, regardless of the product form ──
    buildLegend();
    renderCalendar();
    updateTexts();

    // ─── Cart submission (wired lazily; never blocks the render above) ──────────

    function pushSpeedUpgradeItem(items, selectedKey, variantId, bookingId) {
      var upgradeVariantId = null, windowLabel = '';
      if (selectedKey === 'priority' && priorityUpgradeVariantId) { upgradeVariantId = priorityUpgradeVariantId; windowLabel = 'Priority Build'; }
      else if (selectedKey === 'rush' && rushUpgradeVariantId)    { upgradeVariantId = rushUpgradeVariantId; windowLabel = 'Rush Build'; }
      else if (selectedKey === 'sea' && seaUpgradeVariantId)      { upgradeVariantId = seaUpgradeVariantId; windowLabel = 'Sea Freight'; }
      if (!upgradeVariantId) return;
      items.push({ id: Number(upgradeVariantId), quantity: 1, properties: {
        _pdc_item_type:'production_speed_upgrade', _pdc_booking_id:bookingId, _pdc_upgrade_for:String(variantId),
        _pdc_production_window:selectedKey, _pdc_production_window_label:windowLabel } });
    }

    var isSubmitting = false;
    function resetSubmitState() {
      isSubmitting = false;
      if (addButton) { addButton.removeAttribute('disabled'); addButton.classList.remove('is-loading'); addButton.setAttribute('aria-disabled', 'false'); }
    }
    function handleAdd(event) {
      if (event) { event.preventDefault(); event.stopPropagation(); if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation(); }
      if (isSubmitting) return false;
      isSubmitting = true;
      if (addButton) { addButton.setAttribute('disabled', 'disabled'); addButton.setAttribute('aria-disabled', 'true'); addButton.classList.add('is-loading'); }
      var variantId = getCurrentVariantId();
      if (!variantId) { alert('Please select a product variant first.'); resetSubmitState(); return false; }
      if (!selectedDate || !selectedWindowKey) {
        alert('Please choose a delivery date before adding to cart.');
        if (container.scrollIntoView) container.scrollIntoView({ behavior:'smooth', block:'center' });
        resetSubmitState(); return false;
      }
      var cfg = windowsConfig[selectedWindowKey];
      var dateISO = toISODate(selectedDate);
      var customerDeliveryDate = formatDateForCustomer(selectedDate);
      var bookingId = createPdcBookingId();
      var standardFallback = getFirstDateForWindow('standard');
      // Customer sees only "Delivery date" + "Delivery option". The 3 underscore-
      // prefixed props are private (hidden from customer) and used by pdc-cart-guard.
      var items = [{ id: Number(variantId), quantity: 1, properties: {
        'Delivery date': customerDeliveryDate,
        'Delivery option': cfg.cartLabel || cfg.label,
        _pdc_booking_id: bookingId,
        _pdc_delivery_option: selectedWindowKey,
        _pdc_standard_delivery_date_formatted: formatDateForCustomer(standardFallback),
        // Captured from the live section settings so the cart guard can recompute the
        // current free/standard date without hardcoding the offset.
        _pdc_standard_lead_min_days: String(windowsConfig.standard.leadMinDays)
      } }];
      pushSpeedUpgradeItem(items, selectedWindowKey, variantId, bookingId);
      fetch(cartUrl('/cart/add.js'), { method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, credentials:'same-origin', body: JSON.stringify({ items: items }) })
        .then(function (res) { if (!res.ok) return res.text().then(function (t) { throw new Error(t || 'Cart request failed'); }); return res.json(); })
        .then(function () { window.location.href = cartUrl('/cart'); })
        .catch(function (err) { console.error(err); alert('Something went wrong while adding this configuration to your cart. Please try again.'); resetSubmitState(); });
      return false;
    }

    // Lazily find the product form + add button. Retries for a few seconds so the
    // calendar works even when the form renders after the calendar or lives elsewhere.
    (function wireCart() {
      var tries = 0;
      (function attempt() {
        var wrapper = container.closest('product-form') || container.closest('form[action^="/cart/add"]') ||
                      document.querySelector('product-form') || document.querySelector('form[action^="/cart/add"]');
        var form = wrapper ? (wrapper.tagName && wrapper.tagName.toLowerCase() === 'form' ? wrapper : wrapper.querySelector('form')) : null;
        var btn = form ? (form.querySelector('button[name="add"]') || form.querySelector('[type="submit"]'))
                       : (wrapper ? (wrapper.querySelector('button[name="add"]') || wrapper.querySelector('[type="submit"]')) : null);
        if (form && btn) {
          productForm = form; addButton = btn;
          if (!form.dataset.pdcCartWired) {
            form.dataset.pdcCartWired = 'true';
            form.addEventListener('submit', handleAdd, true);
            btn.addEventListener('click', handleAdd, true);
          }
          return;
        }
        if (tries++ < 20) setTimeout(attempt, 150); // ~3s of retries
      })();
    })();
  }

  // ─── Boot ───────────────────────────────────────────────────────────────────

  function bootDeliveryCalendars(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var containers = scope.querySelectorAll('.delivery-calendar');
    if (!containers.length) return;
    containers.forEach(initCalendar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootDeliveryCalendars(); }, { once: true });
  } else {
    bootDeliveryCalendars();
  }

  // Re-init when a section is (re)loaded in the theme editor or by dynamic loaders.
  document.addEventListener('shopify:section:load', function (e) {
    bootDeliveryCalendars(e.target || document);
  });
})();